import React from "react";
import { CFormSelect } from "@coreui/react";
import { useEffect } from "react";

const SelectInput = ({
  label,
  value,
  onChange,
  options,
  className,
  disabled,
}) => {
  useEffect(() => {
    const isValid = options.some((option) => option.value == value);

    if (value && !isValid) {
      onChange("");
    }
  }, [value, JSON.stringify(options)]);
  return (
    <CFormSelect
      className={className}
      label={label}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      <option style={{ backgroundColor: "var(--cui-tertiary-bg)" }}></option>
      {options.map((option) => (
        <option
          value={option.value}
          style={{ backgroundColor: "var(--cui-tertiary-bg)" }}
        >
          {option.label}
        </option>
      ))}
    </CFormSelect>
  );
};

export default SelectInput;
